import { ActionTree, Module, MutationTree } from 'vuex'
import { RootState } from '../types'
import repository from '@/repository'

const getDefaultState = (): PurchaseOrderNumberState => {
  return {
    purchaseOrderNumber: '',
    isLoading: false,
    errorMessage: '',
    isError: false,
  }
}

const state = getDefaultState()

const mutations: MutationTree<PurchaseOrderNumberState> = {
  reset(state) {
    Object.assign(state, getDefaultState())
  },
  setPurchaseOrderNumber(state, value: unknown) {
    state.purchaseOrderNumber =
      value === null || typeof value === 'undefined' ? '' : String(value)
  },
  setIsLoading(state, value) {
    state.isLoading = value
  },
  setErrorMessage(state, value) {
    state.errorMessage = value
  },
  setIsError(state, value) {
    state.isError = value
  },
}

const actions: ActionTree<PurchaseOrderNumberState, RootState> = {
  async fetchPurchaseOrderNumber({ commit }) {
    commit('setIsLoading', true)
    commit('setIsError', false)
    commit('setErrorMessage', '')

    return repository.PurchaseOrderNumber.GetBillingPONumber()
      .then((response: { data?: unknown }) => {
        const poNumber = response?.data || ''
        commit('setPurchaseOrderNumber', poNumber)
      })
      .catch(
        (error: { response?: { data?: { messageLocalizable?: string } } }) => {
          commit('setIsError', true)
          commit(
            'setErrorMessage',
            error?.response?.data?.messageLocalizable ||
              'ErrorMessageLocalizable'
          )
        }
      )
      .finally(() => {
        commit('setIsLoading', false)
      })
  },
  async addPurchaseOrderNumber(
    { commit },
    inputPayload: { BillingPoNumber: unknown }
  ) {
    const normalizedPoNumber = String(
      inputPayload?.BillingPoNumber ?? ''
    ).trim()
    const payload = { BillingPoNumber: normalizedPoNumber }

    commit('setIsLoading', true)
    commit('setIsError', false)
    commit('setErrorMessage', '')

    return repository.PurchaseOrderNumber.AddBillingPONumber(payload)
      .then((response: { data?: boolean }) => {
        if (response?.data === true) {
          commit('setPurchaseOrderNumber', normalizedPoNumber)
          return
        }

        commit('setIsError', true)
        commit('setErrorMessage', 'ErrorMessageLocalizable')
      })
      .catch(
        (error: { response?: { data?: { messageLocalizable?: string } } }) => {
          commit('setIsError', true)
          commit(
            'setErrorMessage',
            error?.response?.data?.messageLocalizable ||
              'ErrorMessageLocalizable'
          )
        }
      )
      .finally(() => {
        commit('setIsLoading', false)
      })
  },
  clearErrorMessage({ commit }) {
    commit('setIsError', false)
    commit('setErrorMessage', '')
  },
}

const PurchaseOrderNumber: Module<PurchaseOrderNumberState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default PurchaseOrderNumber

interface PurchaseOrderNumberState {
  purchaseOrderNumber: string
  isLoading: boolean
  errorMessage: string
  isError: boolean
}
